import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux/store/store";
import { ToastContainer } from "react-toastify";
// import { ThemeProvider } from "./hooks/theme/ThemeContext";
import "./shared/theme/themes.css"; // Import global styles

// Fix: `document.getElementById('root')` should be cast as `HTMLElement`
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <ThemeProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer position="top-right" autoClose={2000} />
        <RouterProvider router={router} />
      </PersistGate>
    </Provider>
  // </ThemeProvider>
);

reportWebVitals();
